import React, { Component } from 'react';
import { observer } from 'mobx-react';
import SystemTranslationProgress from './SystemTranslationProgress';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import SystemTranslationInstructionAudioProgressService from '../services/SystemTranslationInstructionAudioProgressService';

class SystemTranslationInstructionAudioProgressContainer extends Component {
  systemTranslationInstructionAudioProgressService = new SystemTranslationInstructionAudioProgressService();

  componentDidMount() {
    this.systemTranslationInstructionAudioProgressService.init(this.props.locale);
  }

  render() {
    return (
      <SystemTranslationProgress
        title="Instruction Audios"
        percentage={this.systemTranslationInstructionAudioProgressService.progress.percentage}
        total={this.systemTranslationInstructionAudioProgressService.progress.translated}
        fetching={this.systemTranslationInstructionAudioProgressService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/instruction-audios',
            query: { localeMissingAudio: this.props.locale.key },
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

SystemTranslationInstructionAudioProgressContainer.propTypes = {
  locale: PropTypes.shape({
    key: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  }).isRequired,
};

export default observer(SystemTranslationInstructionAudioProgressContainer);
